import { Typography } from '@material-ui/core';
import React from 'react';

import { publicaColors } from '~/src/dash/utils/colors';
import { IIASDashboardTableBreadCrumb } from '~/src/dash/views/ias-publisher/IASDashboard/IASDashboardTable/common';

interface IIASDashboardTableBreadCrumbsProps {
  crumbs: IIASDashboardTableBreadCrumb[];
  handleBreadCrumbClick: (crumb: IIASDashboardTableBreadCrumb) => void;
  handleBreadCrumbClear: () => void;
}

export const IASDashboardTableBreadCrumbs = ({
  crumbs,
  handleBreadCrumbClick,
  handleBreadCrumbClear,
}: IIASDashboardTableBreadCrumbsProps) => {
  const breadCrumbs: any = [];
  crumbs.map((crumb, i) => {
    breadCrumbs.push(
      <>
        <span
          onClick={() => handleBreadCrumbClick(crumb)}
          style={{
            cursor: 'pointer',
            color: publicaColors.blue,
            fontWeight: 500,
          }}
        >
          {crumb.groupByLabel}
        </span>
        {i !== crumbs.length - 1 ? (
          <span style={{ fontWeight: 500 }}>{` / `}</span>
        ) : (
          <span>{` / ${crumb.label}`}</span>
        )}
      </>,
    );
  });
  return (
    <Typography style={{ fontSize: 14 }}>
      {breadCrumbs}
      <span
        onClick={handleBreadCrumbClear}
        style={{
          color: publicaColors.blue,
          cursor: 'pointer',
          paddingLeft: 16,
        }}
      >
        Clear
      </span>
    </Typography>
  );
};
